
import { MaterialReactTable, MRT_ToggleFiltersButton, MRT_ToggleGlobalFilterButton, useMaterialReactTable } from "material-react-table";
import { Link } from "react-router-dom";
import { CER_WCN_TABLE_COLUMNS } from "./CERWcnTableColumns";
import React, { useEffect, useMemo, useState } from "react";
import {  GenericDropdown, Label, Button, ICONS, Icon } from "abs-ui-components";
import { useSelector } from "react-redux";
import { Autocomplete, Checkbox, Chip, TextField } from "@mui/material";
import axiosHttp from "../../../services/interceptor";
import { accessAPIForResponse } from "../../../services/api-services/api-implementations";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { downloadAllReportDocuments, searchWcn, wcnLoadOptions } from "../CERHelpers";
import BreadCrumb from "../../../common/breadCrumb/BreadCrumb";
import AbsModal from "../../../common/absModal/AbsModal";
import ImportCERModal from "./ImportCERModal";
import { emitToasterMsg } from "../../../services/toasterUtility";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { Modal, COLORS } from "abs-ui-components"; // Modal/COLORS alongside your existing Button, ICONS, Icon import
import AutocompleteDropdown from "../../../common/autocompleteDropdown/AutocompleteDropdown";
import { assignReviewer, claimReport, deleteReport, getDeleteState, unclaimReport } from "../CERHelpers";
const CURRENT_YEAR = new Date().getFullYear();
const START_YEAR = 2024;

const YEAR_OPTIONS = Array.from(
    { length: CURRENT_YEAR + 1 - START_YEAR + 1 },
    (_, i) => {
        const year = START_YEAR + i;
        return { label: String(year), value: year };
    }
).reverse();


export const HighlightedCell = ({
    value,
    columnId,
    reportListColumnFilters,
    user,
}) => {

    const currentFilter =
        reportListColumnFilters.find(
            (f) => f.id === columnId
        );

   const rawValues = currentFilter?.value;

    const selectedValues = Array.isArray(rawValues)
        ? rawValues
        : rawValues != null && rawValues !== ""
            ? [rawValues]
            : [];

    const normalizedSelectedValues = selectedValues.map((item) => {

        if (item === "@Me") {
            return user?.email;
        }

        if (item === "@Unassigned") {
            return "";
        }

        return item;
    });

    const isMatched =
        Array.isArray(normalizedSelectedValues) &&
        normalizedSelectedValues.includes(value);

    return (
        <span
            style={{
                backgroundColor: isMatched
                    ? "rgb(255, 203, 127)"
                    : "transparent",
                color: isMatched
                    ? "black"
                    : "inherit",
                padding: "2px 4px",
                borderRadius: "4px",
            }}
        >
            {value}
        </span>
    );
};

export const MultiSelectFilter = React.memo(({
    columnId,
    options,
    placeholder,
    columnWidth,
    getFilterValue,
    updateFilterValue,
}) => {

    return (
        <Autocomplete
            multiple
            options={options}
            disableCloseOnSelect
            value={getFilterValue(columnId) || []}
            isOptionEqualToValue={(option, value) => option === value}
            onChange={(e, newValue) => {
                updateFilterValue(columnId, newValue);
            }}
            size="small"

            renderOption={(props, option, { selected }) => (
                <li {...props} key={option}>
                    <Checkbox checked={selected} />
                    {option}
                </li>
            )}

            renderTags={(value, getTagProps) =>
                <Chip
                    label={value.length > 1 ? `${value.length} ${columnId}s selected` : value[0]}
                    size="small"
                    sx={{
                        backgroundColor: "gray",
                        color: "white",

                        "& .MuiChip-deleteIcon": {
                            color: "white",
                        },
                    }}
                />
            }

            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="standard"
                    placeholder={placeholder}
                />
            )}

            sx={{
                width: columnWidth || "auto",

                "& .MuiInputBase-input": {
                    color: "white",
                },

                "& .MuiSvgIcon-root": {
                    color: "white",
                },

                "& .MuiInput-underline:before": {
                    borderBottomColor: "white",
                },

                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottomColor: "white",
                },

                "& .MuiInput-underline:after": {
                    borderBottomColor: "white",
                },
            }}
        />
    );
});

export const CERWcnTable = () => {

    const baseURL = process.env.REACT_APP_BASE_URL;
    const user = useSelector((state) => state.userInfo.userData);
    const [tableData, setTableData] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 25,
    });
    const navigate = useNavigate();
    const [columnFilters, setColumnFilters] = useState([]);
    const [globalFilter, setGlobalFilter] = useState("");
    const [sorting, setSorting] = useState([]);

    const [pendingColumnFilters, setPendingColumnFilters] = useState([]);
    const [pendingGlobalFilter, setPendingGlobalFilter] = useState("");
    const [appliedGlobalFilter, setAppliedGlobalFilter] = useState("");
    const [engineersOptions, setEngineersOptions] = useState([]);
    const [openImportModal, setOpenImportModal] = useState(false);
   const [loading, setLoading] = useState(false);
   const CER_SELECTED_YEAR_KEY = "cerSelectedYear";

const getInitialReportingYear = () => {
    const storedYear = sessionStorage.getItem(CER_SELECTED_YEAR_KEY);

    if (storedYear) {
        return Number(storedYear);
    }

    return CURRENT_YEAR;
};

const initialReportingYear = getInitialReportingYear();

const [selectedYearOption, setSelectedYearOption] = useState([
    {
        label: String(initialReportingYear),
        value: initialReportingYear,
    },
]);

const [showAssignModal, setShowAssignModal] = useState(false);
const [selectedEngineer, setSelectedEngineer] = useState("");
const [selectedReportId, setSelectedReportId] = useState(null);
const [confirmDelete, setConfirmDelete] = useState(false);
const [selectedRow, setSelectedRow] = useState(null);
    const breadcrumb = useMemo(
        () => [
            {
                label: "Annual Emission Verification",
                url: "",
                navId: "annual_emission_verification_navid",
            },
            {
                label: "EU MRV Company Emission  Reports",
                url: "/eumrv-company-emission-verification-report",
                navId: "company_emission_verification_reports_navid",
            },
        ],
        []
    );

   const getAllEngineers = async (input) => {
    try {
        const response = await accessAPIForResponse("GetReviewEngineers", null, [input]);
        if (response) {
            const emails = response.map((engineer) => engineer.emailAddress);
            setEngineersOptions(emails);
            return emails.map((email) => ({ label: email, value: email }));   // <-- returns data
        }
        setEngineersOptions([]);
        return [];
    } catch (error) {
        console.error("Error fetching engineers:", error);
        setEngineersOptions([]);
        return [];
    }
};

    const getCerWcnData = async () => {
        try {
            setLoading(true);
            const payload = {
                globalFilter: appliedGlobalFilter,
                filters: columnFilters.map((filter) => ({
                    key: filter.id,
                    value: Array.isArray(filter.value)
                        ? filter.value.map((item) => {
                            if (item === "@Me") {
                                return user?.email;
                            }

                            if (item === "@Unassigned") {
                                return "";
                            }

                            return item;
                        })
                        : filter.value,
                })),
                pagination: {
                    page: pagination.pageIndex + 1,
                    pageSize: pagination.pageSize,
                },
                sortOption: {
                    sortField: sorting?.[0]?.id ?? "",
                    isAscending: !sorting?.[0]?.desc,
                },
                reportYear: selectedYearOption[0]?.value ?? CURRENT_YEAR,
            };
            const response = await axiosHttp.post(
                `${baseURL}api/CompanyVerification/GetWcnCerGrid`,
                payload
            );

            setTableData(response?.data?.data ?? []);

            setRowCount(
                response?.data?.pagination?.totalItems ?? 0
            );
        } catch (error) {
            console.error("Failed to fetch CER WCN data", error);
        }finally{
            setLoading(false);
        }
    };

    useEffect(() => {
        getCerWcnData();
    }, [pagination, columnFilters, sorting, appliedGlobalFilter,selectedYearOption]);

    const applyFilters = () => {
        const cleanedFilters = pendingColumnFilters
            .map(filter => {
                if (Array.isArray(filter.value)) {
                    return {
                        ...filter,
                        value: filter.value.map(v =>
                            typeof v === 'string' ? v.trim() : v
                        ).filter(v => v !== "")
                    };
                }
                if (typeof filter.value === 'string') {
                    const trimmedValue = filter.value.trim();
                    return trimmedValue === "" ? null : { ...filter, value: trimmedValue };
                }
                return filter;
            })
            .filter(filter => filter !== null &&
                (!Array.isArray(filter.value) || filter.value.length > 0)
            );
        setColumnFilters(cleanedFilters);
        setAppliedGlobalFilter(pendingGlobalFilter?.trim() || "");

        setPagination((prev) => ({
            ...prev,
            pageIndex: 0,
        }));
        setPendingColumnFilters(cleanedFilters);
    };

    const clearFilters = () => {
        setPendingColumnFilters([]);
        setColumnFilters([]);
        setPendingGlobalFilter("");
        setGlobalFilter(""); // Reset the input
        setAppliedGlobalFilter("");
        setPagination((prev) => ({
            ...prev,
            pageIndex: 0,
        }));
    };
    // add near your other helpers, above the component or inside it:
const extractYearValue = (selected) => {
    if (selected == null) return undefined;
    if (typeof selected === "number") return selected;
    if (typeof selected === "string") return Number(selected);
    if (typeof selected === "object") {
        if ("value" in selected) return Number(selected.value);
        if ("label" in selected) return Number(selected.label);
        if ("id" in selected) return Number(selected.id);
    }
    return undefined;
};

 const onReportYearChange = (selected) => {
    const raw = Array.isArray(selected) ? selected[0] : selected;
    const yearValue = extractYearValue(raw);

    if (yearValue) {
        const yearOption = {
            label: String(yearValue),
            value: yearValue,
        };

        setSelectedYearOption([yearOption]);

        sessionStorage.setItem(
            CER_SELECTED_YEAR_KEY,
            String(yearValue)
        );

        setPagination((prev) => ({
            ...prev,
            pageIndex: 0,
        }));
    }
};

    useEffect(() => {
        if (!pendingGlobalFilter && appliedGlobalFilter !== "") {
            setAppliedGlobalFilter("");
            setPagination((prev) => ({
                ...prev,
                pageIndex: 0,
            }));
        }
    }, [pendingGlobalFilter, appliedGlobalFilter]);

    const getFilterValue = (columnId) =>
        pendingColumnFilters.find((f) => f.id === columnId)?.value || [];

    const updateFilterValue = (columnId, value) => {
        setPendingColumnFilters((prev) => {
            const others = prev.filter((f) => f.id !== columnId);

            if (!value?.length) {
                return others;
            }

            return [...others, { id: columnId, value }];
        });
    };

    useEffect(() => {
        getAllEngineers("");
    }, []);

    const handleDownloadBtnClick = async (row) => {
        try {
            const response = await downloadAllReportDocuments(
                row.original.companyVerificationReportId
            );

            const url = window.URL.createObjectURL(
                new Blob([response.data], {
                    type: "application/zip",
                })
            );

            const link = document.createElement("a");
            link.href = url;
            link.download = `VerificationDocuments_${row.original.companyVerificationReportId}.zip`;

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
            emitToasterMsg("success", "", "The file downloaded successfully");
        } catch (error) {
            console.error("Download failed", error);
            emitToasterMsg("failed", "", "Download failed");
        }
    };

    const handlesearchwcns = async (inputValue) => {
        try {
            const response = await searchWcn(inputValue);
            const options = response?.data?.map((item) => ({
                label: `${item.WcnNumber} - ${item.CompanyName}`,
                value: item.WcnMstId,
                wcnNumber: item.WcnNumber,
                companyName: item.CompanyName,
                wcnMappingId: item.WcnMstId,
                controlRiskId: item.ControlRiskId,
                inherentRiskId: item.InherentRiskId,
            }));
            return options;
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    
        const handleAssignClick = (row) => {
            setSelectedReportId(row.original.companyVerificationReportId);
            setSelectedEngineer(
                row.original.reviewer ||
                row.original.verifier ||
                ""
            );
    
            setShowAssignModal(true);
        };
    
        const handleAssign = async () => {
            try {
                await assignReviewer(
                    selectedReportId,
                    selectedEngineer
                );
    
                emitToasterMsg("success", "CER Report", "Assigned Successfully"
                );
    
                setShowAssignModal(false);
                getCerWcnData();
            } catch (error) {
                emitToasterMsg("error", "CER Report", "Assignment failed"
                );
            }
        }
    
        const handleSelect = (selected) => {
            if (!selected) {
                setSelectedEngineer(null); 
                return;
            }
    
            setSelectedEngineer(
                selected.value || selected.email || selected
            );
        };
    
        const toggleClose = () => {
            setShowAssignModal(false);
        };
    
        const handleClaim = async (row) => {
            try {
                await claimReport(
                    baseURL,
                    row.original.companyVerificationReportId,
                    user.email
                );
    
                emitToasterMsg("success", "CER Report", "Claimed Successfully"
                );
    
                getCerWcnData();
            } catch (error) {
                console.error(error);
            }
        };
    
        const handleUnClaim = async (row) => {
            try {
                await unclaimReport(
                    row.original.companyVerificationReportId,
                );
    
                emitToasterMsg("success", "CER Report", "Unclaimed Successfully"
                );
    
                getCerWcnData();
            } catch (error) {
                emitToasterMsg("error", "CER Report", "Unclaim failed"
                );
            }
        };
    
        const handleDelete = async () => {
        try {
            const isOnlyRecordOnPage = tableData.length === 1;

            await deleteReport(selectedRow.original.companyVerificationReportId);
            emitToasterMsg("success", "CER Report", "Deleted Successfully");
            setConfirmDelete(false);
            setSelectedRow(null);

            if (isOnlyRecordOnPage && pagination.pageIndex > 0) {
                // page became empty -> go to previous page (the useEffect refetches)
                setPagination((prev) => ({ ...prev, pageIndex: prev.pageIndex - 1 }));
            } else {
                // same page (or the only page) -> just refetch, table shows "No records to display"
                getCerWcnData();
            }
        } catch (error) {
            console.error(error);
            emitToasterMsg("error", "CER Report", "Failed to delete the report");
        }
    };
    useEffect(() => {

        if (openImportModal) {
            handlesearchwcns();
        }
    }, [openImportModal]);

    const table = useMaterialReactTable({
        columns: [
            ...CER_WCN_TABLE_COLUMNS,
           
    {
    id: "actions",
    header: "",
    size: 50,
    enableColumnActions: false,
    enableColumnFilter: false,
    enableSorting: false,
    Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "1rem" }}>
            <Tooltip title="Download">
                <Button
                    outline={true}
                    isIconOnly
                    variant="tertiary"
                    disabled={!row.original?.isDocsAvaialble}
                    onClick={(e) => {
                        if (row.original?.isDocsAvaialble) {
                            e.preventDefault();
                            e.stopPropagation();
                            handleDownloadBtnClick(row);
                        }
                    }}
                >
                    <Icon icon={ICONS.DOWNLOAD} disabled={!row.original?.isDocsAvaialble} className="d-flex" outline={true} size="24px" />
                </Button>
            </Tooltip>
        </Box>
    ),
},
{
    id: "deleteAction",
    header: "",
    size: 60,
    enableColumnActions: false,
    enableColumnFilter: false,
    enableSorting: false,
    Cell: ({ row }) => {
        const reviewerRole = user?.roles?.includes("ER_REVIEWER");
        const verifierRole = user?.roles?.includes("ER_VERIFIER");
        const superAdminRole = user?.roles?.includes("ER_SUPERADMIN");

        const { show, disabled } = getDeleteState({
            reviewerRole,
            verifierRole,
            superAdminRole,
            status: row.original.status,
        });

        if (!show) return null;

        return (
            <Tooltip title="Delete">
                <IconButton
                    color="error"
                    disabled={disabled}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setSelectedRow(row);
                        setConfirmDelete(true);
                    }}
                >
                    <DeleteIcon />
                </IconButton>
            </Tooltip>
        );
    },
},
{
    accessorKey: "status",
    header: "Status",

        Cell: ({ cell, row }) => (
            <Link
                to={`/company-verification-report/${row.original.companyVerificationReportId}`}
                onClick={(e) => e.stopPropagation()}
                style={{
                    color: "inherit",
                    textDecoration: "none",
                }}
            >
                <HighlightedCell
                    value={cell.getValue()}
                    columnId="status"
                    reportListColumnFilters={pendingColumnFilters}
                    user={user}
                />
            </Link>
        ),

    Filter: () => (
        <MultiSelectFilter
            columnId="status"
            options={[
                "Crosscheck In Progress",
                "Verification In Progress",
                "Verification Completed",
            ]}
            placeholder="Filter Status"
            columnWidth='300px'
            getFilterValue={getFilterValue}
            updateFilterValue={updateFilterValue}
        />
    ),
},
            {
                accessorKey: "reviewer",
                header: "Latest Reviewer",

               Cell: ({ cell, row }) => (
                    <Link
                        to={`/company-verification-report/${row.original.companyVerificationReportId}`}
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            color: "inherit",
                            textDecoration: "none",
                        }}
                    >
                        <HighlightedCell
                            value={cell.getValue()}
                            columnId="reviewer"
                            reportListColumnFilters={pendingColumnFilters}
                            user={user}
                        />
                    </Link>
                ),

                Filter: () => (
                    <MultiSelectFilter
                        columnId="reviewer"
                        options={[
                            ...(user?.roles?.some(
                                (role) =>
                                    role === "ER_REVIEWER" || role === "ER_SUPERADMIN"
                            ) ? ["@Me"] : []),
                            "@Unassigned",
                            ...engineersOptions
                        ]}
                        placeholder="Filter by Reviewer"
                        columnWidth='300px'
                        getFilterValue={getFilterValue}
                        updateFilterValue={updateFilterValue}
                    />
                ),
            },
            {
                accessorKey: "verifier",
                header: "Latest Verifier",

               Cell: ({ cell, row }) => (
                <Link
                    to={`/company-verification-report/${row.original.companyVerificationReportId}`}
                    onClick={(e) => e.stopPropagation()}
                    style={{
                        color: "inherit",
                        textDecoration: "none",
                    }}
                >
                    <HighlightedCell
                        value={cell.getValue()}
                        columnId="verifier"
                        reportListColumnFilters={pendingColumnFilters}
                        user={user}
                    />
                </Link>
            ),

                Filter: () => (
                    <MultiSelectFilter
                        columnId="verifier"
                        options={[
                            ...(user?.roles?.some(
                                (role) =>
                                    role === "ER_VERIFIER" || role === "ER_SUPERADMIN"
                            ) ? ["@Me"] : []),
                            "@Unassigned",
                            ...engineersOptions
                        ]}
                        placeholder="Filter by Verifier"
                        columnWidth='300px'
                        getFilterValue={getFilterValue}
                        updateFilterValue={updateFilterValue}
                    />
                ),
            },
            {
    id: "assignActions",
    header: "",
    size: 120,
    enableColumnActions: false,
    enableColumnFilter: false,
    enableSorting: false,
    Cell: ({ row }) => {
        const reviewerRole = user?.roles?.includes("ER_REVIEWER");
        const verifierRole = user?.roles?.includes("ER_VERIFIER");
        const superAdminRole = user?.roles?.includes("ER_SUPERADMIN");

        const reportStatus = row.original.status;
        const reviewer = row.original.reviewer;

        const isReviewerUser = reviewerRole && !verifierRole && !superAdminRole;
        const isVerifierUser = verifierRole || superAdminRole;

        if (isReviewerUser) {
            const isMine = reviewer === user?.email;
            if (reportStatus === "Verification Completed" || reportStatus === "Verification In Progress") {
                return <p>Claimed by <br />{reviewer}</p>;
            }
            if (reviewer && !isMine) {
                return <span style={{ fontSize: 12 }}>Claimed by {reviewer}</span>;
            }
            return (
                <Button size="small" onClick={(e) => { e.preventDefault(); e.stopPropagation(); isMine ? handleUnClaim(row) : handleClaim(row); }}>
                    {reviewer ? "Unclaim" : "Claim"}
                </Button>
            );
        }

        if (isVerifierUser) {
            if (reportStatus === "Verification Completed") {
                return <p>Claimed by <br />{reviewer}</p>;
            }
            return (
                <Button size="small" onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleAssignClick(row); }}>
                    {reviewer ? "Re-Assign" : "Assign"}
                </Button>
            );
        }
        return null;
    },
},
        ],
       muiTableBodyRowProps: ({ row }) => ({
    sx: { cursor: "pointer !important", '&:hover': { backgroundColor: 'action.hover' } },
    onClick: () => {
        navigate(`/company-verification-report/${row.original.companyVerificationReportId}`, {
            state: { reportId: row.original.companyVerificationReportId },
        });
    },
}),
        muiTableBodyCellProps: {
            sx: {
                cursor: "pointer",
            },
        },
        data: tableData,
        enableStickyHeader: true,
        manualPagination: true,
        manualFiltering: true,
        manualSorting: true,
        enableFullScreenToggle: false,
        toggledensity: false,
        rowCount,
        enableExpandAll: false,
        enableExpanding: false,
        //enableBatchRowSelection: true,
        enableSorting: false,
        //filterFromLeafRows: true,
        enableTopToolbar: true,
        enableHiding: false,

        state: {
            pagination,
            columnFilters: pendingColumnFilters,
            //globalFilter: pendingGlobalFilter,
            globalFilter: pendingGlobalFilter,
            sorting,
            isLoading:loading,
        },
        onPaginationChange: setPagination,
        onColumnFiltersChange: (updater) => {
            const newFilters =
                typeof updater === "function"
                    ? updater(pendingColumnFilters)
                    : updater;

            setPendingColumnFilters(newFilters);

            if (newFilters.length === 0) {
                setColumnFilters([]);
                setPagination((prev) => ({
                    ...prev,
                    pageIndex: 0,
                }));
            }
        },
        onGlobalFilterChange: setPendingGlobalFilter,
        onSortingChange: setSorting,
        initialState: {
            density: "compact",
            columnOrder: [
                "actions",
                "wcnNumber",
                "companyName",
                "xmlCompanyName",
                "companyImoNumber",
                "cvrId",              
                "modifiedDate",
                "status",
                "assignActions",
                "reviewer",
                "verifier",
                 "deleteAction",
            ],
        },
        renderToolbarInternalActions: ({ table }) => (
            <>
                <MRT_ToggleGlobalFilterButton
                    id="reports_view_global_search"
                    table={table}
                />
                <MRT_ToggleFiltersButton
                    id="reports_view_global_filter"
                    table={table}
                />
                <Button
                    className="ml-2"
                    onClick={applyFilters}
                >
                    Apply Filters
                </Button>
                <Button
                    className="ml-2"
                    variant="secondary"
                    onClick={clearFilters}
                >
                    Clear
                </Button>
            </>
        ),
        muiFilterTextFieldProps: ({ column }) => ({
            placeholder: "Type and Search",
            onKeyDown: (e) => {
                if (e.key === "Enter") {
                    applyFilters();
                }
            },
        }),
        muiSearchTextFieldProps: {
            placeholder: "Type and Enter",
            onKeyDown: (e) => {
                if (e.key === "Enter") {
                    applyFilters();
                }
            },
        },
    });

    const toggleImportCER = (success) => {
        setOpenImportModal(!openImportModal);
        if (success) {
            getCerWcnData();
        }
    };

    return (
        <>
 <div className="report-list-container p-4">

    {/* Breadcrumb - Left */}
    <div className="mb-2">
        <BreadCrumb items={breadcrumb} />
    </div>

    {/* Reporting Year - Left | Import Button - Right */}
    <div
        className="d-flex justify-content-between align-items-center mb-3"
        style={{ position: "relative", zIndex: 20 }}
    >
        {/* Reporting Year */}
        <div
            className="reporting-yr-wrapper d-flex align-items-center"
            style={{ position: "relative", zIndex: 20 }}
        >
            <Label className="mr-3" name="Reporting Year" bold />

            <div
                className="drop-down-container"
                style={{ position: "relative", zIndex: 20 }}
            >
                <GenericDropdown
                    options={YEAR_OPTIONS}
                    selected={selectedYearOption}
                    handleChange={onReportYearChange}
                    placeholder={selectedYearOption[0]?.label}
                />
            </div>
        </div>

        {/* Import Button - Right */}
        <Button onClick={() => setOpenImportModal(true)}>
            Import Company Emission Report
        </Button>
    </div>


            {openImportModal && (
                <AbsModal
                    isOpen={openImportModal}
                    title={
                        <div
                            style={{
                                minWidth: "35px",
                                minHeight: "172px",
                            }}
                        >
                            <div>Import Company</div>
                            <div>Emission Report</div>
                        </div>
                    }
                    onClose={setOpenImportModal}
                    close={toggleImportCER}
                >
                   <ImportCERModal onClose={toggleImportCER}reportingYear={selectedYearOption[0]?.value ?? CURRENT_YEAR}/>

                </AbsModal>
            )}


            <MaterialReactTable table={table} />
            
            
                            {showAssignModal && (
                                <div className="assign-modal">
                                    <AbsModal
                                        isOpen={showAssignModal}
                                        title={"Assignment"}
                                        onClose={setShowAssignModal}
                                        close={toggleClose}
                                    >
                                        <div className="ml-3">
                                            <h4 className="blod">Assignment</h4>
                                            <hr />
                                            <p>Please select an Engineer</p>
                                            <hr />
                                            <AutocompleteDropdown
                                                className="inputHeight"
                                                id="search-vessel-id"
                                                isClearable
                                                loadOptions={async (inputText) => {
                                                    const options = await getAllEngineers(
                                                        inputText
                                                    );
                                                    return options;
                                                }}
                                                placeholder={
                                                    selectedEngineer || "Select an Engineer"
                                                }
                                                autoFocus={false}
                                                onChange={handleSelect}
                                                customStyles={{
                                                    menuList: (provided) => ({
                                                        ...provided,
                                                    }),
                                                }}
                                            />
            
                                            <div className="d-flex justify-content-end mr-3 assignment-model-btns">
                                                <Button
                                                    className="mr-3"
                                                    id="assign-claim-btn-report-list"
                                                    onClick={() => {
                                                        handleAssign(
                                                            selectedEngineer
                                                        );
                                                    }}
                                                >
                                                    Assign/Reassign
                                                </Button>
                                                <Button
                                                    id="cancel-btn-report-list"
                                                    variant="secondary"
                                                    onClick={() => {
                                                        toggleClose();
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </AbsModal>
                                </div>
            
                            )}
                            
                            {confirmDelete && (
                                <div className="confirmation-modal-container">
                                    <Modal
                                        isOpen={confirmDelete}
                                        modalHeader
                                        padding={"70px"}
                                        headerHeight={"50px"}
                                        showFooter
                                        onCloseClickListener={() => {
                                            setConfirmDelete(false);
                                        }}
                                        footer={
                                            <div className="d-flex justify-content-end fixed-action-btns p-4">
                                                <Button
                                                    className="modal-delete-btn"
                                                    onClick={() => handleDelete(selectedRow)}
                                                    primaryColor={COLORS.RED.DARK}
                                                    primaryBackgroundColor={COLORS.RED.LIGHT}
                                                >
                                                    Delete
                                                </Button>
                                                <Button
                                                    className="modal-cancel-btn"
                                                    onClick={() => {
                                                        setConfirmDelete(false);
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        }
                                    >
                                        <div>Are you sure you want to delete this CER Report</div>
                                    </Modal>
                                </div>
                            )}
                            </div>
                    
        </>
    );
}